// Core
import { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// Components
import { Button, FieldSelect, FieldText, SectionCard } from "components/AtomsV2";
import { Icon } from "components/ShellV2";

function BasicInfo({ data, onUpdate, isLoading }) {
  const [original, setOriginal] = useState(data);

  const [name, setName] = useState(data.name);
  const [type] = useState(data.type);
  const [status, setStatus] = useState(data.status);

  const { t } = useTranslation(["resources"]);

  const canSave =
    [name, type, status].every(Boolean) &&
    !isLoading &&
    !(original.name === name && original.type === type && original.status === status);

  const onUpdateResourceClicked = async () => {
    if (canSave) {
      const success = await onUpdate({
        name,
        status,
      });

      if (success) {
        setOriginal({ name, type, status });
      }
    }
  };

  const statusOptions = [
    { value: "ACTIVE", label: t("table.filters.status.active") },
    { value: "INACTIVE", label: t("table.filters.status.inactive") },
  ];

  const typeLabel = t(`new_resource.selects.types.${type}`, { defaultValue: type || "—" });

  return (
    <SectionCard
      id="general"
      icon="badge"
      title={t("single.general.title")}
      action={
        <Button variant="ghost" size="sm" disabled={!canSave} onClick={onUpdateResourceClicked}>
          <Icon name="save" />
          {t("single.general.update")}
        </Button>
      }
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <FieldText
          label={t("new_resource.form.designation.label")}
          value={name}
          onChange={setName}
        />
        <FieldSelect
          label={t("new_resource.form.type.label")}
          value={type}
          options={[{ value: type, label: typeLabel }]}
          disabled
        />
        <FieldSelect
          label={t("new_resource.form.status.label")}
          value={status}
          options={statusOptions}
          onChange={setStatus}
        />
      </div>
    </SectionCard>
  );
}

BasicInfo.defaultProps = {
  isLoading: false,
};

BasicInfo.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
  onUpdate: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default BasicInfo;
